export enum ViewType {
  RED = "Red",
  GREEN = "Green",
  YELLOW = "Yellow",
  UNKNOWN = "Unknown",
}

export default ViewType;
